const CONNECTIVITY_INTERRUPTION = '/connectivity-interruption';

export const ROUTE_HOME_CONNECTIVITY_INTERRUPTION = CONNECTIVITY_INTERRUPTION + '/home';

export const connectivityInterruptionRoutes = [ROUTE_HOME_CONNECTIVITY_INTERRUPTION];